import { useMemo, useState } from 'react';

export const useURLImage = ({
    src,
    onLoad
}: {
    src: string;
    onLoad?: (img: HTMLImageElement) => void;
}) => {
    const [image, setImage] = useState<HTMLImageElement>();
    const [isLoading, setIsLoading] = useState(true);
    const [isSuccess, setIsSuccess] = useState(false);
    const [isError, setIsError] = useState(false);
    useMemo(() => {
        const img = new Image();
        img.onerror = () => {
            setIsError(true);
        };
        img.onload = () => {
            setImage(img);
            setIsLoading(false);
            setIsSuccess(true);
            if (onLoad) onLoad(img);
        };
        img.crossOrigin = 'Anonymous';
        img.src = src;
    }, [src]);

    return { image, isLoading, isSuccess, isError };
};

export default useURLImage;
